import { render, staticRenderFns } from "./DeletedCard.vue?vue&type=template&id=6015b902&scoped=true&"
import script from "./DeletedCard.vue?vue&type=script&lang=js&"
export * from "./DeletedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015b902",
  null
  
)

export default component.exports